import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'

const PaymentStatusDialog = ({
  open,
  onClose,
  onConfirm,
  newStatus,
  currentStatus,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Payment Status Change</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to change the payment status from{' '}
          <strong>{currentStatus}</strong> to <strong>{newStatus}</strong>?
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
          This change will be saved immediately.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PaymentStatusDialog
